<template>
  <div class="main">
    <a-layout-content class="content">
      <img src="/loginpic.png" alt="" class="logo">
    </a-layout-content>
    <!--<a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
      <a-form-item >
        <a-input
          size="large"
          v-model="cardNo"
          autocomplete="false"
          placeholder="请输入卡号"
          v-decorator="[
                'cardNo',
                {rules: [{ required: true, message: '请输入卡号' }], validateTrigger: 'blur'}
              ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item >
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
        >请求发卡</a-button>
      </a-form-item>
     &lt;!&ndash; <a-form-item >
        <p  v-if="isShow"  class="word-v-middle">{{GrantCardMessage}}</p>
      </a-form-item>&ndash;&gt;
    </a-form>-->
  </div>
</template>

<script>
  import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
  import { QRCodeGrantCard } from '@/api/logistics'
  import config from '@/config/defaultSettings'

  export default {
    components: {
      TwoStepCaptcha
    },
    data () {
      return {
        isShow:false,
        cardNo :'',
        GrantCardMessage: '请求发卡中...',
        verificationCode:'',
        form: this.$form.createForm(this),
        state: {
          time: 60,
          loginBtn: false,
          // login type: 0 email, 1 username, 2 telephone
          loginType: 0,
          smsSendBtn: false
        }
      }
    },
    created () {
      if(this.$route.params){
          if(this.$route.params.verificationCode){
              this.verificationCode=this.$route.params.verificationCode
          }
      }
      if(this.verificationCode){
          this.getQRCodeGrantCard()
      }

    },
    methods: {
      getQRCodeGrantCard() {
        var verificationCode=this.verificationCode
        QRCodeGrantCard({verificationCode:verificationCode})
          .then(res => {
             var attachementId=res.data
            var QRcodeUrl=this.config.imgApiUrl+attachementId
            window.location.href=QRcodeUrl
          //  window.open(QRcodeUrl)
           /* if(res.code !='0'){
              this.GrantCardMessage=res.message;
            }else{
              this.GrantCardMessage='发卡成功!'
            }*/
            //this.isShow=true
            return res.data
          }).catch(() => {
          console.log(e)
        }).finally(() => {
        })
      },
      handleSubmit (e) {
        const _this = this
        this.form.validateFields((err, values) => {
          if (!err) {
            e.preventDefault()

            var verificationCode = this.verificationCode
            var cardNo = this.cardNo
            QRCodeGrantCard({"verificationCode": verificationCode, "cardNo": cardNo})
              .then(res => {
                if (res.code != '0') {
                  this.GrantCardMessage = res.message;
                } else {
                  this.GrantCardMessage = '发卡成功!'
                }
                return res.data
              }).catch(() => {
              this.GrantCardMessage = '发卡异常!'
              console.log(e)
            }).finally(() => {
                this.isShow=true
            })
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .content{
    width: 100%;
    height: 100%;
    margin-top: -100px;
  }
  .content .logo{
    width:100%;
    height: 51px;
    margin-top: -410px;

  }
  .label{
    font-size: 20px;

  }
  .user-layout-login {
    width: 310px;
    /*height: 400px;*/
    /*background-color: #d8dce0;*/
    /*border-radius: 20px; */
    margin: -60px auto;
    padding: 20px;
  }


  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  &:hover {
     color: #1890ff;
   }
  .word-v-middle{
    margin-bottom: 0;
    font-size: 16px;
    min-height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 31px;
    margin-top: 5px;
    color: #87878a;
    white-space: normal;
  }
  .word-v-middle span{
    text-align: left;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
    background-color: #D8160E;
    border-color: #D8160E;
  }
</style>
